import { render, staticRenderFns } from "./tag-right.vue?vue&type=template&id=f33bf8ae&"
import script from "./tag-right.vue?vue&type=script&lang=js&"
export * from "./tag-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f33bf8ae')) {
      api.createRecord('f33bf8ae', component.options)
    } else {
      api.reload('f33bf8ae', component.options)
    }
    module.hot.accept("./tag-right.vue?vue&type=template&id=f33bf8ae&", function () {
      api.rerender('f33bf8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/tag-right.vue"
export default component.exports